//
// each placement will use one of the following image types
// the type defines the image size and aspect ratio
export const UAPImageType = {
  Image1x1: 'Image1x1',
  Image4x1: 'Image4x1',
  Image1x2: 'Image1x2',
  Image191x100: 'Image191x100',
  Image178x100: 'Image178x100',
  Image172x100: 'Image172x100',
  Image169x100: 'Image169x100',
  Image155x100: 'Image155x100',
  Image150x100: 'Image150x100',
  Image133x100: 'Image133x100',
  Image93x100: 'Image93x100',
  Image201x100: 'Image201x100',
  Image200x100: 'Image200x100',
  Image153x100: 'Image153x100',
  Image124x100: 'Image124x100',
  Image120x100: 'Image120x100',
  Image122x100: 'Image122x100',
  Image159x100: 'Image159x100',
  Image180x100: 'Image180x100',
  Image233x100: 'Image233x100',
  Image320x100: 'Image320x100',
  Image57x100: 'Image57x100',
};

export const UAPVideoType = {
  VideoMedia16X9: 'VideoMedia16X9',
  VideoMedia5X4: 'VideoMedia5X4',
  VideoMedia1X1: 'VideoMedia1X1',
  VideoMedia4X5: 'VideoMedia4X5',
  VideoMedia9X16: 'VideoMedia9X16',
};
